import ENV_VARS from '@/config'
import { post, put, del } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

export const sendFile = post(`${BACKEND_SERVER}/secure/%tag%`)
export const deleteFile = del(`${BACKEND_SERVER}/secure/%tag%/%fileId%`)
export const updateFile = put(`${BACKEND_SERVER}/secure/%tag%/%fileId%`)
